import { Routes } from '@angular/router';
import { onboardingResolver } from './resolver/onboarding-resolver';
import { appGuard } from './guards/app-guard';
import { canDeactivatePartnerGuard } from './guards/can-deactivate-partner.guard';
import { canDeactivatePartnerContactGuard } from './guards/can-deactivate-partner-contact.guard';
import { adminRoleGuard } from './guards/admin-role.guard';
import { superAdminRoleGuard } from './guards/super-admin-role.guard';

export const routes: Routes = [
    {
        path: 'auth',
        children: [
            {
                path: 'login',
                loadComponent: () => import('./components/auth/login/login').then(m => m.Login)
            },
            {
                path: 'register',
                loadComponent: () => import('./components/auth/register/register').then(m => m.Register)
            },
            {
                path: 'reset-password',
                loadComponent: () => import('./components/auth/reset-password/reset-password').then(m => m.ResetPassword)
            },
            {
                path: 'recover',
                loadComponent: () => import('./components/auth/recover/recover').then(m => m.Recover)
            },
            {
                path: 'onboarding',
                loadComponent: () => import('./components/auth/onboarding/onboarding').then(m => m.Onboarding),
                resolve: {
                    onboarding: onboardingResolver
                }
            },
            {
                path: 'outlook/callback',
                loadComponent: () => import('./components/auth/outlook-callback/outlook-callback').then(m => m.OutlookCallback)
            },
            {
                path: 'google/callback',
                loadComponent: () => import('./components/auth/google-callback/google-callback').then(m => m.GoogleCallback)
            },
            {
                path: 'inviteEmployee',
                loadComponent: () => import('./components/auth/invite-employee/invite-employee').then(m => m.InviteEmployee)
            }
        ]
    },
    {
        path: '',
        loadComponent: () => import('./layouts/main-layout/main-layout').then(m => m.MainLayout),
        canActivate: [appGuard],
        children: [
            {
                path: '',
                redirectTo: '/dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./components/features/dashboard/dashboard').then(m => m.Dashboard)
            },
            // Sessions
            {
                path: 'sessions/new',
                loadComponent: () => import('./components/features/sessions/new-session/new-session').then(m => m.NewSession)
            },
            {
                path: 'sessions/open',
                loadComponent: () => import('./components/features/sessions/open-sessions/open-sessions').then(m => m.OpenSessions)
            },
            {
                path: 'sessions/confirmed',
                loadComponent: () => import('./components/features/sessions/confirmed-appointments/confirmed-appointments').then(m => m.ConfirmedAppointments)
            },
            {
                path: 'sessions/past',
                loadComponent: () => import('./components/features/sessions/past-appointments/past-appointments').then(m => m.PastAppointments)
            },
            // Partners
            {
                path: 'partners/companies',
                loadComponent: () => import('./components/features/partners/partner-companies/partner-companies').then(m => m.PartnerCompanies)
            },
            {
                path: 'partners/companies/add',
                loadComponent: () => import('./components/features/partners/add-edit-partner/add-edit-partner').then(m => m.AddEditPartner),
                canDeactivate: [canDeactivatePartnerGuard]
            },
            {
                path: 'partners/companies/edit/:id',
                loadComponent: () => import('./components/features/partners/add-edit-partner/add-edit-partner').then(m => m.AddEditPartner),
                canDeactivate: [canDeactivatePartnerGuard]
            },
            {
                path: 'partners/contacts',
                loadComponent: () => import('./components/features/partners/partner-contacts/partner-contacts').then(m => m.PartnerContacts)
            },
            {
                path: 'partners/contacts/add',
                loadComponent: () => import('./components/features/partners/add-edit-partner-contract/add-edit-partner-contract').then(m => m.AddEditPartnerContract),
                canDeactivate: [canDeactivatePartnerContactGuard]
            },
            {
                path: 'partners/contacts/edit/:id',
                loadComponent: () => import('./components/features/partners/add-edit-partner-contract/add-edit-partner-contract').then(m => m.AddEditPartnerContract),
                canDeactivate: [canDeactivatePartnerContactGuard]
            },
            //employees
            {
                path: 'employees/management',
                loadComponent: () => import('./components/features/employee/employee-management/employee-management').then(m => m.EmployeeManagement),
                canActivate: [adminRoleGuard]
            },
            // Company
            {
                path: 'company/management',
                loadComponent: () => import('./components/features/company/company-management/company-management').then(m => m.CompanyManagement),
                canActivate: [superAdminRoleGuard]
            },
            {
                path: 'company/subscription',
                loadComponent: () => import('./components/features/company/subscription-management/subscription-management').then(m => m.SubscriptionManagement),
                canActivate: [superAdminRoleGuard]
            }
        ]
    },
    // Addons
    {
        path: 'addons/recruiting',
        loadChildren: () => import('./addons/recruiting/recruiting.routes').then(m => m.recruitingRoutes)
    },
    // Public appointment session routes
    {
        path: 'appointment-selection/partner/:id',
        loadComponent: () => import('./components/features/sessions/partner-selection/partner-selection').then(m => m.PartnerSelection)
    },
    {
        path: 'appointment-selection/participant/:id',
        loadComponent: () => import('./components/features/sessions/participant-selection/participant-selection').then(m => m.ParticipantSelection)
    },
    // Public recruiting candidate view
    {
        path: 'recruiting/candidate-view/:id',
        loadComponent: () => import('./addons/recruiting/components/features/candidate-view/candidate-view').then(m => m.CandidateView)
    },
    // Public recruiting partner view
    {
        path: 'recruiting/partner-view/:id',
        loadComponent: () => import('./addons/recruiting/components/features/partner-view/partner-view').then(m => m.PartnerView)
    },
    // Default routes
    {
        path: '**',
        loadComponent: () => import('./components/auth/not-found/not-found').then(m => m.NotFound)
    }
];
